import { Component, Input, SimpleChanges } from '@angular/core';
import { Breadcrumb } from '@app/core/model/breadcrumb';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input()
  public breadcrumbs: Breadcrumb[];


}
